var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"login-layout"}},[_c('img',{staticClass:"background",attrs:{"src":require("@/assets/img/bg_login.jpg"),"alt":""}}),_c('div',{staticClass:"content"},[_vm._m(0),_c('div',[_c('router-view')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("@/assets/img/ensineme.png"),"alt":""}})])
}]

export { render, staticRenderFns }